import React, { PureComponent } from 'react';
import AppWrapper from '../shared/appWrapper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchSequence } from '../../actions/sequence';
import { FetchCities } from '../../actions/cities';
import { FetchCyoaProducts } from '../../actions/products';
import MapBox from '../shared/mapbox/index';
import ItinerarySlider from './components/itinerarySlider';
// import { updateUrlParameter } from '../../helpers/utils'; (DEPRECATE)
import _filter from 'lodash/filter';
import Spinner from '../shared/spinner';
import ResponsiveImage from '../shared/responsiveImage';
import { CYOA_NETWORK_IDS } from '../../config';
import { getCyoaID, getCyoaName } from '../../helpers/cyoaHelper';

const queryString = require('query-string');
let qs = queryString.parse(window.location.search);

class Preview extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      optionalSelect:2,
      styleSelect:0
    }
    this.onBookNowClicked = this.onBookNowClicked.bind(this);
    // this.handleSelectChange = this.handleSelectChange.bind(this); //(DECPRECATE)
    this.onBackClicked = this.onBackClicked.bind(this);
  }


  componentDidUpdate(prevProp, prevState){

     const {
       FetchCyoaProducts,
       sequence,
       sequence:{header},
       currency,
       currency:{iso_currency_code},
       FetchSequence,
       FetchCities,
     } = this.props;

     

    if(currency !== prevProp.currency){
      FetchSequence(qs.guid, qs.style, qs.optionals, qs.city, iso_currency_code, qs.stops, null, qs.bundle, qs.custom, getCyoaID());
      FetchCities(iso_currency_code, getCyoaID());
    }


    if(sequence !== prevProp.sequence){

      //set style and options
      this.setState({styleSelect:header.params.style.charAt(0), optionalSelect:header.params.optionals.charAt(0)});

      //check sequence has product and load image
      const hasProduct = _filter(sequence.data.sequence, (item) => item.tour_id !== CYOA_NETWORK_IDS["europe"].id && item.tour_id !== CYOA_NETWORK_IDS["usa"].id);
      if(hasProduct.length > 0){
        FetchCyoaProducts(iso_currency_code, getCyoaID());
      }
    }

  }

  renderCitiesList(arr){
    const newCitiesArray = arr.map(item => (item.type === 'sector' || item.type === 'pre_trip') ? ` ${item.name}` : `<span> ${item.name}</span>`);
    return {__html: newCitiesArray };
  }

  renderCitiesListString(arr){
    const newCitiesArray = arr.map(item => (item.type === 'sector' || item.type === 'pre_trip') ? ` ${item.name}` : ` ${item.name}`);
    return newCitiesArray.join();
  }

  renderSequence(sequence, city, product){
    for(let i = 0; i < city.length; i++){
      for(let ii = 0; ii < sequence.length; ii++){
        if(city[i].ctfl_id === sequence[ii].city_id){
          sequence[ii].images = city[i].images;
          sequence[ii].description = city[i].description;
          sequence[ii].descriptionLong = city[i].descriptionLong;
        }

        if(product.length !== 0){
          for(let j = 0; j < product.length; j++){
            if(product[j].name === sequence[ii].city){
              sequence[ii].images = product[j].media;
              sequence[ii].description = product[j].name;
              sequence[ii].descriptionLong = product[j].descriptionShort;
            }
          }
        }

      }
    }
    return sequence;
  }


  renderOptionalOrStyle(optional, styles){
    return {
      name: (optional.length !== 0) ? "Optional Stops:" : "Styles:",
      options: (optional.length !== 0) ?  optional : styles
    }
  }

  onBookNowClicked(){

    const {
      sequence:{ header },
      currency:{iso_currency_code},
    } = this.props;
    const { optionalSelect, styleSelect } = this.state;

    const destination = (qs.destination !== undefined ? `&destination=${qs.destination}` : "");

    if(header.params.sequence_type === "quote"){
      window.parent.location.href =  `${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DEPARTURE_PAGE}?guid=${qs.guid}&currency=${iso_currency_code}${destination}`;
    }else{
      window.parent.location.href = `${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DEPARTURE_PAGE}?guid=${qs.guid}&style=${styleSelect}&optionals=${optionalSelect}&city=${header.params.city}&currency=${iso_currency_code}&stops=${header.params.stops}&bundle=${qs.bundle}${destination}`;
    }

  }

  //(DECPRECATE)
  /*handleSelectChange(e){

    const {
      FetchSequence,
      sequence
    } = this.props;

    //Remove all mapContainer contents
    var div = document.getElementById('previewView');
    while(div.firstChild)div.removeChild(div.firstChild);

    if(sequence.header.optionals_dropdown.length !== 0){

      //Update optional state
      this.setState({optionalSelect: e.target.value});

      //Populate new query parameters
      updateUrlParameter('optionals', e.target.value);

      //Recall sequence API
      FetchSequence(qs.guid, qs.style, e.target.value, qs.city, qs.currency, qs.stops, null, qs.bundle, qs.custom);

    }else{

      //Update style style
      this.setState({optionalSelect: e.target.value});

      //Populate new query parameters
      updateUrlParameter('style', e.target.value);

      //Recall sequence API
      FetchSequence(qs.guid, e.target.value, this.state.optionalSelect, qs.city, qs.currency, qs.stops, null, qs.bundle, qs.custom);

    }

  }*/

  onBackClicked(){
    if(qs.share !== undefined){
      const destination = (qs.destination !== undefined ? `?destination=${qs.destination}` : "");
      window.parent.location.href = `${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DISCOVER_PAGE}${destination}`;
    }else{
      this.props.history.goBack();
    }
  }


  render(){

    if(Object.keys(this.props.sequence).length === 0){
      return <Spinner text="Loading itinerary..." loadClass="orange-spinner-wrapper"/>
    }else{
      // const { optionalSelect, styleSelect } = this.state; //(DEPRECATE)
      const { sequence:{data:{name, sub_name, sequence, start_city, nr_cities, min_days, nr_trips, nr_countries, nr_stops}, /*header:{optionals_dropdown, styles_dropdown}*/ }, cities:{data},  cyoaProducts} = this.props;

      const _cities = (this.renderCitiesListString(sequence).length !== 0) ? this.renderCitiesListString(sequence) : [];
      const _sequence = (this.props.sequence && sequence !== undefined) ? sequence : "";
      const _cyoaProducts = (cyoaProducts !== undefined && Object.keys(cyoaProducts).length > 0) ? cyoaProducts.data : [];
      const _citiesData = (this.props.cities && data !== undefined) ? data : "";
      const _startCity = (this.props.sequence && start_city !== undefined) ? start_city : "";
      const _sequenceWithImage = this.renderSequence(_sequence, _citiesData, _cyoaProducts);
      const _imageFilter = _filter(_citiesData, ['name', _startCity]);
      const _image = (_imageFilter !== undefined && _imageFilter[0] !== undefined) ? _filter(_imageFilter[0].images, {'title': 'hero'})[0].url : "";
      // const _dropdown = this.renderOptionalOrStyle(optionals_dropdown, styles_dropdown); //(DEPRECATE)
      // const _styleOrOptionalState = (_dropdown.name === "Optional Stops:") ? optionalSelect : styleSelect; //(DEPRECATE)

      const minTr = 234;
      const maxTr = 658;
      let _randomTravellersNumber = 0;
      if (_randomTravellersNumber === 0) {
        _randomTravellersNumber = _randomTravellersNumber === 0 ? Math.floor(Math.random() * (maxTr - minTr + 1)) + minTr : _randomTravellersNumber;
      }


      return (
        <React.Fragment>
          <AppWrapper className={`itinerary ${ nr_trips > 0 ? 'has-product' : "" }`} navbar={false} back={false} skip={false} text="Itinerary" onBackClick={this.onBack}>
          <button className="lity-close lity-back" onClick={this.onBackClicked}><i className="arrow left"></i></button>
          <button className="lity-close" onClick={this.onBackClicked}>×</button>
            <div className="row text-center margin-t-50">
              <div className="column small-12 medium-10 large-8 small-centered">
                <div className="itinerary-city-circle">
                  <ResponsiveImage width={98} widthRetina={196} src={_image} alt={name} quality={60} />
                </div>
                <h3 className="busabout-h3 uppercase no-margin">
                  {name} <span className="stop-text">{`${nr_stops} stops`}</span>
                <small>
                  <svg className={`${ nr_trips > 0 ? '' : 'hide' }`} width="12" height="12" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"/></svg>
                 {sub_name}</small>
                </h3>
                <p className="no-margin cities-text">Visit {_cities} 
                { getCyoaName() !== "usa" && <span className="normal">  and meet approximately <strong className="orange-text">{_randomTravellersNumber} travellers</strong> on your way.</span>}
                </p>
              </div>
            </div>

            <div className="row text-center margin-t-40">
              <div className="column small-12">
              <ul>
                <li>
                  <p className="no-margin">
                    <span className="subtitle">{ `${qs.destination === "usa" ? "Stops:" : "Countries:"}` }</span>
                    <span className="orange-text bold">{ `${qs.destination === "usa" ? `${nr_stops} Stops` : `${nr_countries} Countries`}` }</span>
                  </p>
                </li>
                <li>
                  <p className="no-margin">
                    <span className="subtitle">{ `${qs.destination === "usa" ? "Destinations:" : "Cities:"}` }</span>
                    <span className="orange-text bold">{nr_cities} Cities</span>
                  </p>
                </li>
                 <li>
                  <p className="no-margin">
                    <span className="subtitle">Duration: </span>
                    <span className="orange-text bold">{min_days} days</span>
                  </p>
                </li>
                <li>
                  <button className="busabout--cta orange" onClick={this.onBookNowClicked}>Continue</button>
                </li>
              </ul>
            </div>

            </div>

            {/* (DECPRECATE) */}
            {/* <div className="row text-center optional-wrapper hide">
              <div className="column small-12 medium-6">
                <p className="no-margin optional-text"><span className="subtitle">{_dropdown.name}</span></p>
              </div>
              <div className="column small-12 medium-6">
                <select className="itinerary-selectdropdown" defaultValue={_styleOrOptionalState} onChange={this.handleSelectChange}>
                  {
                    Object.keys(_dropdown.options).map(function(key, index) {
                      return <option key={index} value={key}>{_dropdown.options[key]}</option>
                    })
                  }
                </select>
              </div>
            </div> */}


          </AppWrapper>

            <div className="itinerary-map-wrapper margin-t-40">
                <MapBox countriesShow={_sequence} clickable={true} id={"previewView"} />
            </div>


            <div className="row margin-t-70">
              <div className="columns small-12 large-11 large-offset-0-5 itinerarySlider-wrapper">
                <ItinerarySlider sequenceWithImage={_sequenceWithImage} destination={getCyoaName()} />
              </div>
            </div>

            <div className="row text-center margin-t-60 margin-b-300">
              <div className="columns small-12 margin-b-60">
                  <p><strong>You can customise any aspect of your trip and save to book later.</strong> </p>
              </div>
              <div className="column small-12">
                <button className="busabout--cta orange" onClick={this.onBookNowClicked}>Continue</button>
              </div>
              <div className="columns small-12 margin-t-20">
                 {getCyoaName() !== "usa" &&  <p>You will meet around <strong className="orange-text">{_randomTravellersNumber} travellers</strong> on this trip</p> }
              </div>
            </div>
        </React.Fragment>
      )

    }
  }

}

function mapStateToProps(state){
  return {
    sequence:state.sequence.data,
    currency:state.currency,
    cities:state.cities,
    cyoaProducts:state.cyoaProducts
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchSequence,
    FetchCities,
    FetchCyoaProducts
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Preview);



// WEBPACK FOOTER //
// ./src/components/preview/index.js